import styled from 'styled-components';

// Pulsante con gli stili di un link
export const StyledButtonLikeLink = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.colorPrimary};
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  text-decoration: underline;
  &:hover {
    color: ${props => props.theme.colorPrimaryHover};
  }
`;
